<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header bg-primary">
          <h4 class="card-title text-white mb-0">Owner details</h4>
        </div>
        <div class="card-body pt-3">
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <div class="row">
                <div class="col-sm-12 form-group">
                  <validation-input label="Customer type" rules="required">
                    <div class="btn-group btn-group-toggle btn-block">
                      <label v-for="o in lovs.TYPE" :key="o.value" :class="['btn btn-light', data.CS_DATA.TYPE === o.value && 'active']">
                        <input v-model="data.CS_DATA.TYPE" :value="o.value" type="radio" />
                        {{ o.text }}
                      </label>
                    </div>
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="Birthdate" rules="required">
                    <datepicker-input v-model="data.CS_DATA.BIRTHDATE" />
                   <!-- <flat-pickr v-model="data.CS_DATA.BIRTHDATE" :config="config" class="form-control" /> -->
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="License issue date" rules="required">
                    <cleave-input type="date" v-model="data.CS_DATA.LICENSE_DATE_ISSUE" placeholder="__/____" />
                    <!-- <cleave class="form-control" v-model="data.CS_DATA.LICENSE_DATE_ISSUE" :options="cleaveOptionDate" placeholder="__/____"></cleave> -->
                  </validation-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 d-flex">
                  <div class="mr-auto">
                    <button type="button" class="btn btn-secondary" @click="previous">Previous</button>
                  </div>
                  <div class="ml-auto">
                    <button type="submit" class="btn btn-primary">Next</button>
                  </div>
                </div>
              </div>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    lovs: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    onSubmit() {
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    }
  }
};
</script>
